// Modules
import React from 'react'
import { Route, Routes } from 'react-router-dom'

// Views
import Landing from '../views/landing/Landing'

// Route: Register > Main
function Main () {
	// Render
	return (
		<Routes>
			<Route
				path="/"
				element={<Landing />} />
		</Routes>
	)
}

// Export
export default Main
